<svg xmlns="http://www.w3.org/2000/svg" width="13.459" height="16.05" viewBox="0 0 13.459 16.05">
    <defs>
        <style>.map-pin-grey{opacity:0.4;}.map-pin-grey-b{fill:none;stroke:#08123b;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.8px;}</style>
    </defs>
    <g class="map-pin-grey" transform="translate(0.9 0.9)">
        <path class="map-pin-grey-b" d="M14.659,6.83c0,4.534-5.83,8.42-5.83,8.42S3,11.364,3,6.83a5.83,5.83,0,1,1,11.659,0Z" transform="translate(-3 -1)" />
        <circle class="map-pin-grey-b" cx="1.943" cy="1.943" r="1.943" transform="translate(3.886 3.886)" />
    </g>
</svg>